import { NetworkStatus } from "@apollo/client";

export const LOADING_NETWORK_STATUSES = [
  NetworkStatus.loading,
  NetworkStatus.setVariables,
];
